import { render, staticRenderFns } from "./CommunityTopNav.vue?vue&type=template&id=130e6f7c&scoped=true"
import script from "./CommunityTopNav.vue?vue&type=script&lang=ts"
export * from "./CommunityTopNav.vue?vue&type=script&lang=ts"
import style0 from "./CommunityTopNav.vue?vue&type=style&index=0&id=130e6f7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130e6f7c",
  null
  
)

export default component.exports